export class Person {
    label = () => this.first_name + " " +this.last_name
}

export class Therapy {
    get_therapist = () => Object.assign(new Person(), this.therapist)
    is_not_available = () => (this.is_vacation || this.is_blocked)
    get_vacation_label = () => this.is_vacation ? 'URLOP' : 'NIEOBECNOŚĆ';
}

export class HourMap {

}

export class Patient {

}


// WEBPACK FOOTER //
// ./src/models/models.js